import MerchantBusinessProfilePage from '../../../components/merchant/settings/business/MerchantBusinessProfilePage'

export default function SettingsBusiness() {
  return <MerchantBusinessProfilePage />
}
